import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { selectedHotelSelector } from '../../property/propertySlice';
import { offerLoaderSelector } from '../cmsSlice';
import './Feedback.scss';
import { Drawer } from '@material-ui/core';
import { validateUserSession } from '../../../utils/authUtils';
import {
  FEEDBACK,
  FEEDBACK_CREATE,
  FEEDBACK_EDIT,
  FEEDBACK_VIEW,
} from '../../../constants/FeedbackConst';
import FeedbackCreate from './feedback-create/Feedback-Create';
import FeedbackView from './feedback-view/Feedback-View';
import FeedbackList from './feedback-list/Feedback-List';

const FeedbackPage = (props) => {
  const { permissions, showLoader = () => {} } = props;
  const selectedHotel = useSelector(selectedHotelSelector);
  const loader = useSelector(offerLoaderSelector);
  const history = useHistory();
  const [state, setState] = useState({
    type: FEEDBACK_CREATE,
    status: false,
  });
  const [viewState, setViewState] = useState({
    type: FEEDBACK_VIEW,
    status: false,
    obj: null,
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    validateUserSession(history);
  }, [history]);

  const onDrawerToggle = (type, status, obj) => {
    setState({ type: type, status: status, obj: obj });
  };

  const onViewToggle = (type, status, obj) => {
    setViewState({ type: type, status: status, obj: obj });
  };

  const toggleDrawer = (open) => (event, reason) => {
    if (
      reason === 'backdropClick' ||
      (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift'))
    ) {
      return;
    }
    setState(open);
  };

  const switchDrawerContent = (state) => {
    switch (state.type) {
      case FEEDBACK_CREATE:
        return (
          <FeedbackCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            loader={loader}
            showLoader={showLoader}
          />
        );
      case FEEDBACK_EDIT:
        return (
          <FeedbackCreate
            toggleDrawer={onDrawerToggle}
            feedback={state.obj}
            hotelId={selectedHotel}
            loader={loader}
            showLoader={showLoader}
          />
        );
      default:
        break;
    }
  };

  const switchViewContent = (inpState) => {
    switch (inpState.type) {
      case FEEDBACK_VIEW:
        return (
          <FeedbackView
            permissions={permissions}
            feedback={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
          />
        );
      default:
        break;
    }
  };

  return (
    <>
      <Drawer
        anchor={'right'}
        open={state.status}
        onClose={toggleDrawer(false)}
        className='right-drawer'
      >
        {switchDrawerContent(state)}
      </Drawer>
      {viewState.status ? (
        <>{switchViewContent(viewState)}</>
      ) : (
        <div className='container mt-4'>
          <div className='row d-flex'>
            <div className='col-md-6'>
              <span className='page-title'>{FEEDBACK}</span>
            </div>
          </div>
          <div className='row mx-2 d-flex mt-4'>
            <div className='card shadow'>
              <FeedbackList
                onDrawerToggle={onDrawerToggle}
                onViewToggle={onViewToggle}
                hotelId={selectedHotel}
                loader={loader}
                permissions={permissions}
                onsetPage={(e) => setPage(e)}
                page={page}
                onsetRowsPerPage={(e) => setRowsPerPage(e)}
                rowsPerPage={rowsPerPage}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FeedbackPage;
